import React, { useMemo } from "react";

import { DiaryContainer } from "../../shared/DiaryContainer";
import { DiaryHeader } from "../../shared/DiaryHeader";
import { getDiaryEventsFromDespatchTasks, groupTasksByHour } from "Util/calendar";

import { DiaryCalendar, CalendarEvent, DiaryType } from "../../../../../../components/DiaryCalendar";
import TaskBadge from "../../TaskBadge";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";

export const DiaryWeekView = React.forwardRef(() => {
  const { tasksFiltered, isFetchingTasks, currentDate, setCurrentDate, seeTasksModalRef } =
    useOperationDespatchContext();

  const events = useMemo(() => {
    return getDiaryEventsFromDespatchTasks(tasksFiltered);
  }, [tasksFiltered]);

  const diaryGroups = useMemo(() => {
    return groupTasksByHour(events);
  }, [events]);

  const onSeeTasks = (allEvents: CalendarEvent[], date?: Date) => {
    const taskResources = allEvents.map((event) => event?.resource?.task)?.filter(Boolean);

    seeTasksModalRef.current?.open(taskResources, date);
  };

  return (
    <DiaryContainer>
      <DiaryHeader />

      <DiaryCalendar
        events={diaryGroups}
        viewMode={DiaryType.WEEK}
        loadingEvents={isFetchingTasks}
        date={currentDate}
        onChangeDate={setCurrentDate}
        badgeComponent={TaskBadge}
        onShowMoreEvents={onSeeTasks}
        onSelectEvent={(event) => onSeeTasks([event])}
      />
    </DiaryContainer>
  );
});
